import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";

import avatar from '../../theme/assets/other/lp_cabinet_avatar.png';
import avatarBtn from '../../theme/assets/svg/lp_settings_avatar_btn_icon.svg';
import {
    changeUserAvatar,
    changeUserAvatarFailure, changeUserEmail, changeUserEmailFailure,
    changeUserName,
    changeUserNameFailure
} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";


const SettingsAccount = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const userData = useSelector(store => store.cabinet.userData);
    const changeUserNameStatus = useSelector(store => store.cabinet.changeUserNameStatus);
    const changeUserNameStatusErr = useSelector(store => store.cabinet.changeUserNameStatusErr);
    const changeUserEmailStatusErr = useSelector(store => store.cabinet.changeUserEmailStatusErr);
    const changeUserAvatarStatusErr = useSelector(store => store.cabinet.changeUserAvatarStatusErr);


    const [editUsernameBtnStatus, setEditUsernameBtnStatus] = useState(false);
    const [editEmailBtnStatus, setEditEmailBtnStatus] = useState(false);

    const [email, setEmail] = useState('');
    const [userName, setUsername] = useState('');

    const [avatarFileName, setAvatarFileName] = useState('');
    const [avatarPreview, setAvatarPreview] = useState(null);

    const handleAvatarChange = (event) => {
        dispatch(changeUserAvatarFailure(false));
        const file = event.target.files[0];
        if (!file) return;

        setAvatarFileName(file.name);
        const previewUrl = URL.createObjectURL(file);
        setAvatarPreview(previewUrl);

        dispatch(changeUserAvatar(file));
    };

    useEffect(() => {
        if (userData?.user) {
            setEmail(userData.user.email || '');
            setUsername(userData.user.name || '');
            setEditEmailBtnStatus(userData.user.email || false)
        }
    }, [userData]);

    useEffect(()=>{
        if (changeUserNameStatus){
            setEditUsernameBtnStatus(false);
        }
    }, [changeUserNameStatus])

    useEffect(() => {
        return () => {
            if (avatarPreview) {
                URL.revokeObjectURL(avatarPreview);
            }
        };
    }, [avatarPreview]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Информация об аккаунте')}</div>
                <div className={`${Styles.contentWrapNote}`}>{t('Управляйте своей личной информацией, данными для входа и настройками учётной записи')}.</div>
                <div className={`${Styles.avatarWrap}`}>
                    <div className={`${Styles.avatarBox}`}>
                        {userData ? <img src={userData?.user?.avatar_url || avatar} alt="avatar" /> : null}
                    </div>
                    <div className={`${Styles.avatarDetailsBox}`}>
                        <div className={`${Styles.avatarDetailsBoxNameRow}`}>
                            <div className={`${Styles.avatarDetailsBoxNameRowName}`}>{t('Ваш никнейм')}:</div>
                            <div className={`${Styles.avatarDetailsBoxNameRowValue}`}>{userData?.user?.name}</div>
                        </div>
                        <div className={`${Styles.avatarDetailsBoxEditRow}`}>
                            <div className={`${Styles.avatarDetailsBoxEditRowName}`}>{t('Изменение аватара')}:</div>
                            <div className={`${Styles.avatarDetailsBoxEditRowValue}`}>
                                <div className={`${Styles.avatarDetailsBoxEditRowValue}`}>
                                    <label htmlFor="avatar-upload" className={`${Styles.avatarDetailsBoxEditRowValueBtn}`}>
                                        <img src={avatarBtn} alt="Download avatar"/>
                                    </label>
                                    <input
                                        type="file"
                                        id="avatar-upload"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={handleAvatarChange}
                                    />
                                    <div className={`${Styles.avatarDetailsBoxEditRowValueFileName}`}>
                                        {avatarFileName || t('Загрузить аватар')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.avatarErr}`}>{changeUserAvatarStatusErr?.image}</div>
                </div>
                <div className={`${Styles.changeWrap}`}>
                    <div className={`${Styles.inputWrap}`}>
                        <div className={`${Styles.inputTitleRow}`}>
                            <div className={`${Styles.inputTitle}`}>{!editUsernameBtnStatus ? t("Ваш никнейм") : t('Выбрать никнейм')}</div>
                        </div>
                        <div className={`${Styles.inputBox} ${changeUserNameStatusErr?.username ? Styles.inputBoxErr : null}`}>
                            <input
                                type="text"
                                value={userName}
                                onChange={(e)=>{setUsername(e.target.value)}}
                                placeholder={t("Ваш никнейм")}
                                disabled={!editUsernameBtnStatus}
                                onKeyDown={(event)=>{
                                    if (changeUserNameStatusErr?.username){
                                        delete changeUserNameStatusErr?.username;
                                        dispatch(changeUserNameFailure(changeUserNameStatusErr));
                                    }
                                }}
                            />
                            {editUsernameBtnStatus ?
                                <div
                                    className={`${Styles.inputBoxBtn}`}
                                    onClick={()=>{
                                        dispatch(changeUserName({username: userName}))
                                    }}
                                >
                                    {t('Сохранить')}
                                </div> :
                                <div
                                    className={`${Styles.inputBoxBtn}`}
                                    onClick={()=>{
                                        setEditUsernameBtnStatus(true);
                                        setUsername('');
                                    }}
                                >
                                    {t('Изменить')}
                                </div>
                            }
                        </div>
                        <div className={`${Styles.inputErr}`}>{changeUserNameStatusErr?.username ? changeUserNameStatusErr?.username : ''}</div>
                    </div>
                    <div className={`${Styles.inputWrap}`}>
                        <div className={`${Styles.inputTitleRow}`}>
                            <div className={`${Styles.inputTitle}`}>{editEmailBtnStatus ? t('Ваша почта') : t('Добавить почту')}</div>
                            {/*<div className={`${Styles.inputTitle}`}>{editEmailBtnStatus ? t('Ваша почта') : t('Добавить почту')} <span>{userData?.user?.email && editEmailBtnStatus && !userData?.user?.email_verified ? t('(Не верефицирован)'): ''}</span></div>*/}
                            {/*{userData?.user?.email && editEmailBtnStatus && !userData?.user?.email_verified  ? <div className={`${Styles.verifyBtn}`} onClick={()=>{dispatch(setSettingsVerifyModalStatus(true))}}>{t('Верифицировать')}</div> : null}*/}
                        </div>

                        <div className={`${Styles.inputBox} ${changeUserEmailStatusErr?.email ? Styles.inputBoxErr : null}`}>
                            <input
                                type="text"
                                value={email}
                                onChange={(e)=>{setEmail(e.target.value)}}
                                placeholder={t('Ваша почта')}
                                disabled={editEmailBtnStatus}
                                onKeyDown={(event)=>{
                                    if (changeUserEmailStatusErr?.email){
                                        delete changeUserEmailStatusErr?.email;
                                        dispatch(changeUserEmailFailure(changeUserEmailStatusErr));
                                    }
                                }}
                            />
                            {editEmailBtnStatus ?
                                <div
                                    className={`${Styles.inputBoxBtn}`}
                                    onClick={()=>{
                                        setEmail('');
                                        setEditEmailBtnStatus(false);
                                    }}
                                >
                                    {t('Изменить')}
                                </div> :
                                <div
                                    className={`${Styles.inputBoxBtn}`}
                                    onClick={()=>{
                                        dispatch(changeUserEmail({email: email}))
                                    }}
                                >
                                    {t('Добавить')}
                                </div>
                            }
                        </div>
                        <div className={`${Styles.inputErr}`}>{changeUserEmailStatusErr?.email ? changeUserEmailStatusErr?.email : ''}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SettingsAccount;